export default __webpack_public_path__ + "static/reviewVPic-89ba378f66ecaec43b84b059f3e8dbeb.jpg";